export enum IvrEventType {
  IVREventDial = 'DIAL',
  IVREventEnd = 'END',
  IVREventForward = 'FORWARD',
  IVREventHTTP = 'HTTP',
  IVREventInput = 'INPUT',
  IVREventMenu = 'MENU',
  IVREventMessage = 'MESSAGE',
  IVREventNumberMatch = 'NUMBER_MATCH',
  IVREventSchedule = 'SCHEDULE',
  IVREventSMS = 'SMS',
  IVREventStart = 'START',
  IVREventVariable = 'VARIABLE',
  IVREventVariableMatch = 'VARIABLE_MATCH',
  IVREventVoicemail = 'VOICEMAIL',
}

class IvrSessionContent {
  events: Event[];
  variables: { [key: string]: any };
}

class Event {
  type: IvrEventType;
  event: {
    id: string;
    eventTime: string;
    ivrId: string;
    ivrVersion: number;
    ivrNodeId: string;
    sessionId: string;
    [key: string]: any;
  };
}

export default IvrSessionContent;
